<template>
 <div class="reserve">
  <div class="reserve-title">直播设置</div>
  <div class="com-content">
    <van-field
      v-model="form.liveReserveTime"
      label="开播时间" 
      label-align="left" 
      input-align="right" 
      readonly 
      right-icon="arrow" 
      class="signup-type top" 
      placeholder="请选择时间"
      @click="changeTime"
    />
    <van-field
      v-model="form.roomName"
      label="直播间选择" 
      label-align="left" 
      input-align="right" 
      readonly 
      right-icon="arrow" 
      class="signup-type top" 
      placeholder="请选择直播间"
      @click="isRoomPop = true"
    />
  </div>
  <van-popup position="bottom" style="width: 100%" v-model="showTime">
    <van-datetime-picker
      v-model="currentDate"
      type="datetime"
      title="选择年月日"
      :min-date="minDate"
      :max-date="maxDate"
      @cancel="showTime = false"
      @confirm="timeConfirm"
    />
  </van-popup>
  <van-action-sheet 
    v-model="isRoomPop" 
    :actions="roomList" 
    @select="choiceRoom" 
    cancel-text="取消"
  />
 </div>
</template>

<script>
import dayjs from "@/utils/dayjs";
export default {
  props: {
    value:  {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change', newVal)
      }
    }
  },
  data() {
    return {
      showTime: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      isRoomPop: false,
      roomList: []
    }
  },
  methods: {
    changeTime() {
      this.showTime = true
    },
    timeConfirm(e) {
      this.form.liveReserveTime = dayjs(e).format("YYYY-MM-DD HH:mm:ss");
      this.showTime = false
    },
    choiceRoom(e) {
      this.form.roomId = e.roomId
      this.form.liveRoomId = e.liveRoomId
      this.form.roomName = e.name
      this.isRoomPop = false
    }
  },
  created() {
    this.$api.live.queryLiveRooms().then( res=> {
      this.roomList = []
      res.data.list.forEach(item => {
        this.roomList.push({
          name: item.roomName,
          liveRoomId: item.liveRoomId,
          roomId: item.roomId
        })
      });
      this.form.roomId = this.roomList[0].roomId
      this.form.liveRoomId = this.roomList[0].liveRoomId
      this.form.roomName = this.roomList[0].name
    })
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  margin: 15px 0;
  .reserve-title {
    padding: 0 15px
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    margin 10px 15px
    padding 15px
    background-color: #fff
    border-radius: 8px;
    .signup-type {
      padding: 10px 0;
    }
  }
}
</style>